import { Component, enableProdMode, ViewChild, AfterViewInit } from '@angular/core';
import { AlertController, App, IonicModule, Nav, Platform } from 'ionic-angular';
import { Splashscreen, StatusBar } from 'ionic-native';
import { LoginPage } from "../pages/login/login";

import { CommonService } from "../services/common.service";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'app.html'
})
export class MyApp implements AfterViewInit {
    @ViewChild(Nav) nav: Nav;

    public isAccountTest: boolean = false;
    rootPage = LoginPage;
    static exitConfirm: any;
    public selectedLanguage = 'vi'
    constructor(private app: App,
        private alertCtrl: AlertController,
        private translate: TranslateService,
        platform: Platform, private screenOrientation: ScreenOrientation,
        public cs: CommonService) {

        const storedLanguage = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage;
        } else {
            this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
        }
     
        translate.setDefaultLang(this.selectedLanguage);
        translate.use(this.selectedLanguage);
        platform.ready().then(() => {
            if (!platform.is('mobileweb') && (platform.is('android') || platform.is('ios') || platform.is('windows'))) {
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
            }

            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            //StatusBar.styleDefault();
            StatusBar.backgroundColorByHexString("#05695d");
            //StatusBar.hide();
            Splashscreen.hide();
            platform.registerBackButtonAction(() => {
                let nav = app.getRootNav();
                if (nav.canGoBack()) {
                    app.navPop();
                }
                else {
                    this.confirmExitApp();
                }
            });


            // this.setTheme('theme2');
        });

        this.translate.get('BACK_BUTTON_TEXT').subscribe((res: string) => {
            IonicModule.forRoot(MyApp, {
                backButtonText: res
            });
        });
    }


    setTheme(theme: string) {
        const body = document.body;

        // Remove any existing theme class
        body.classList.remove('theme2');

        // Add new theme class
        if (theme === 'theme2') {
            body.classList.add('theme2');
        } else {
            body.classList.add('theme-default');
        }
    }

    ngAfterViewInit() {
        this.nav.viewDidEnter.subscribe((view) => {
            this.cs.userType > 1 ? this.isAccountTest = true : this.isAccountTest = false;
        });
    }

    confirmExitApp() {
        if (!MyApp.exitConfirm) {
            MyApp.exitConfirm = this.alertCtrl.create({
                message: this.translate.instant('EXIT_APP_MESSAGE'),
                buttons: [
                    {
                        text: this.translate.instant('DISMISS'),
                        handler: () => {
                            // console.log('Hủy');
                        }
                    },
                    {
                        text: this.translate.instant('EXIT'),
                        handler: () => {
                            navigator["app"].exitApp();
                        }
                    }
                ]
            });
            MyApp.exitConfirm.present();
        } else {
            MyApp.exitConfirm.dismiss().catch(() => {
            });
            MyApp.exitConfirm = null;
        }
    }
}

enableProdMode();




// WEBPACK FOOTER //
// ./src/app/app.component.ts